// src/components/admin/CounterForm.js
import React, { useState, useEffect } from 'react';

const CounterForm = ({ user, initialData = {}, services = [], onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    number: '',
    status: 'available', // Default status
    tenant_id: user?.tenant_id, // Auto-fill tenant_id from logged-in user
    assigned_service_ids: [], // To store selected service IDs
    ...initialData,
    // Ensure assigned_service_ids from initialData is properly handled
    assigned_service_ids: initialData.assigned_service_ids || [] 
  });

  const isEditMode = !!initialData.id;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceToggle = (serviceId) => {
    setFormData(prev => {
      const currentAssignments = new Set(prev.assigned_service_ids);
      if (currentAssignments.has(serviceId)) {
        currentAssignments.delete(serviceId);
      } else {
        currentAssignments.add(serviceId);
      }
      return {
        ...prev,
        assigned_service_ids: Array.from(currentAssignments) // Convert Set back to Array
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, isEditMode);
  };

  // Filter services to only show those belonging to the current admin's tenant
  const tenantServices = services.filter(s => s.tenant_id === user?.tenant_id);

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>Counter Number</label>
        <input type="text" name="number" value={formData.number} onChange={handleChange} required />
      </div>
      <div className="admin-form-group">
        <label>Status</label>
        <select name="status" value={formData.status} onChange={handleChange} required>
          <option value="available">Available</option>
          <option value="busy">Busy</option>
          <option value="offline">Offline</option>
        </select>
      </div>

      {/* Service Assignment Checkboxes */}
      <div className="admin-form-group" style={{ gridColumn: '1 / -1' }}> {/* Spans full width */}
        <label>Assigned Services</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '5px' }}>
          {tenantServices.length === 0 ? (
            <p style={{ color: '#888' }}>No services available for this tenant. Add services first.</p>
          ) : (
            tenantServices.map(service => (
              <label key={service.id} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="checkbox"
                  checked={formData.assigned_service_ids.includes(service.id)}
                  onChange={() => handleServiceToggle(service.id)}
                />
                {service.name} ({service.prefix})
              </label>
            ))
          )}
        </div>
      </div>

      <div className="admin-form-actions">
        <button type="submit" className="admin-button submit">{isEditMode ? 'Update Counter' : 'Add Counter'}</button>
        <button type="button" onClick={onCancel} className="admin-button cancel">Cancel</button>
      </div>
    </form>
  );
};

export default CounterForm;